/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdrServiceSearchHitDto
 */
export interface OrdrServiceSearchHitDto {
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    externalReference: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    invoiceMethod: string;
    /**
     * 
     * @type {number}
     * @memberof OrdrServiceSearchHitDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    locationName: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    businessRegisterId: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrdrServiceSearchHitDto
     */
    sourceNo?: string;
}

/**
 * Check if a given object implements the OrdrServiceSearchHitDto interface.
 */
export function instanceOfOrdrServiceSearchHitDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "externalReference" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "invoiceMethod" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "locationName" in value;
    isInstance = isInstance && "businessRegisterId" in value;

    return isInstance;
}

export function OrdrServiceSearchHitDtoFromJSON(json: any): OrdrServiceSearchHitDto {
    return OrdrServiceSearchHitDtoFromJSONTyped(json, false);
}

export function OrdrServiceSearchHitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdrServiceSearchHitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalReference': json['externalReference'],
        'name': json['name'],
        'mail': !exists(json, 'mail') ? undefined : json['mail'],
        'invoiceMethod': json['invoiceMethod'],
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'businessRegisterId': json['businessRegisterId'],
        'sourceId': !exists(json, 'sourceId') ? undefined : json['sourceId'],
        'sourceNo': !exists(json, 'sourceNo') ? undefined : json['sourceNo'],
    };
}

export function OrdrServiceSearchHitDtoToJSON(value?: OrdrServiceSearchHitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalReference': value.externalReference,
        'name': value.name,
        'mail': value.mail,
        'invoiceMethod': value.invoiceMethod,
        'locationId': value.locationId,
        'locationName': value.locationName,
        'businessRegisterId': value.businessRegisterId,
        'sourceId': value.sourceId,
        'sourceNo': value.sourceNo,
    };
}

